import { render, staticRenderFns } from "./CouponUsageRecord.vue?vue&type=template&id=6122c14a&"
import script from "./CouponUsageRecord.vue?vue&type=script&lang=js&"
export * from "./CouponUsageRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports